module.exports = __webpack_public_path__ + "static/media/WU_PAYMENT_bank_inactive.733b6e22.svg";